import { forwardRef } from 'react'

interface SvgProps {
  className?: string
}

const MagnifyingGlass = forwardRef<SVGSVGElement, SvgProps>(({ className }, ref) => {
  return (
    <svg
      ref={ref}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2561_26)">
        <path
          d="M10.5651 19.4805C11.5501 19.4805 12.4893 19.3192 13.3825 18.9965C14.2758 18.6738 15.0814 18.2237 15.7993 17.6463L20.4825 22.4356L21.9852 20.8816L17.3019 16.1178C17.8696 15.3876 18.3121 14.5682 18.6293 13.6596C18.9465 12.7509 19.1051 11.7957 19.1051 10.7937C19.1051 9.58789 18.8797 8.45852 18.4289 7.40557C17.9781 6.35262 17.3687 5.43129 16.6007 4.64158C15.8327 3.85187 14.9228 3.22775 13.8709 2.7692C12.8357 2.32764 11.7338 2.10687 10.5651 2.10687C9.37968 2.10687 8.26938 2.32764 7.23422 2.7692C6.19906 3.22775 5.2933 3.85187 4.51694 4.64158C3.74056 5.43129 3.12699 6.35262 2.67619 7.40557C2.22539 8.45852 2 9.58789 2 10.7937C2 11.9825 2.22539 13.1119 2.67619 14.1818C3.12699 15.2347 3.74056 16.1518 4.51694 16.933C5.2933 17.7143 6.19906 18.3341 7.23422 18.7927C8.26938 19.2512 9.37968 19.4805 10.5651 19.4805ZM10.5651 4.2722C11.45 4.2722 12.2765 4.44203 13.0445 4.78169C13.8292 5.12135 14.5095 5.58838 15.0855 6.18279C15.6615 6.7772 16.1249 7.46501 16.4755 8.24623C16.8094 9.04445 16.9764 9.89357 16.9764 10.7937C16.9764 11.6938 16.8094 12.5345 16.4755 13.3157C16.1249 14.1138 15.6615 14.8102 15.0855 15.4046C14.5095 15.999 13.8292 16.466 13.0445 16.8057C12.2765 17.1453 11.45 17.3152 10.5651 17.3152C9.68019 17.3152 8.84542 17.1453 8.06067 16.8057C7.27595 16.466 6.59559 15.999 6.01958 15.4046C5.44356 14.8102 4.9886 14.1138 4.65468 13.3157C4.32075 12.5345 4.15379 11.6938 4.15379 10.7937C4.15379 9.89357 4.32075 9.04445 4.65468 8.24623C4.9886 7.46501 5.44356 6.7772 6.01958 6.18279C6.59559 5.58838 7.27595 5.12135 8.06067 4.78169C8.84542 4.44203 9.68019 4.2722 10.5651 4.2722Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2561_26">
          <rect
            width="20"
            height="21"
            fill="white"
            transform="translate(2 2)"
          />
        </clipPath>
      </defs>
    </svg>
  )
})

export default MagnifyingGlass

MagnifyingGlass.displayName = 'MagnifyingGlass'
